function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import WDHFeatureB2BCartSpot from '../../../../../wdh-feature/wdh-feature-b2b/src/js/cart-spot';
var OticonHeaderShoppingCartLink = /*#__PURE__*/function () {
  function OticonHeaderShoppingCartLink(selector, container, mobileContainer) {
    _classCallCheck(this, OticonHeaderShoppingCartLink);
    this.selector = selector;
    this.container = container;
    this.mobileContainer = mobileContainer;
    this.shoppingCart = null;
  }
  return _createClass(OticonHeaderShoppingCartLink, [{
    key: "run",
    value: function run(isMobile) {
      var container = isMobile ? this.mobileContainer : this.container;
      this.link = document.querySelector(this.selector);
      if (this.isActive()) {
        this.link.parentNode.removeChild(this.link);
        var mobileLink = document.querySelector('.navigation .shopping-cart-link');
        if (mobileLink) mobileLink.parentNode.removeChild(mobileLink);
        this.shoppingCart = document.createElement('div');
        this.shoppingCart.classList.add('shopping-cart');
        this.shoppingCart.innerHTML = '<div class="component wdh-feature-b2b-cartspot"><div class="component-content"></div></div>';
        container.appendChild(this.shoppingCart);
        new WDHFeatureB2BCartSpot().run();
      }
    }
  }, {
    key: "moveToContainer",
    value: function moveToContainer(isMobile) {
      var container = isMobile ? this.mobileContainer : this.container;
      if (this.shoppingCart && this.shoppingCart.parentElement !== container) {
        container.appendChild(this.shoppingCart);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.link;
    }
  }]);
}();
export default OticonHeaderShoppingCartLink;